<div class="product-card">
  <!-- <div class="ctn-rupture" *ngIf="product.unavailabilityInfo">
    <div class="lbl-rupture">
      <div>
        {{ product.unavailabilityInfo.reason }}
      </div>

      <div>
        {{ product.unavailabilityInfo?.scheduledEnd | date: 'dd/MM/yyyy'}}
      </div>
    </div>
    <div class="ctn-background">

    </div>
  </div>-->
  <header>
    <!-- Code article -->
    <span class="text-gray tag-display-code label label-rounded" *ngIf="product?.displayCode">
      {{ product?.displayCode | codeProduitSuffix:product.isDateCourte }}
    </span>

    <!-- Désignation produit -->
    <a class="title" title="{{ product?.label }}" [routerLink]="['/product', product?.code]">
      {{ product?.label | capitalizeFirstLetter }}<br />
    </a>

    <!-- Marque -->
    <a *ngIf="product?.brandUrl" target="_blank" [routerLink]="['/offers/search', product?.brand]">
      <span class="text-gray brand" *ngIf="product?.brand">
        {{ product?.brand }}
      </span>
    </a>

    <span *ngIf="!product?.brandUrl && product?.brand" class="text-gray brand">
      {{ product?.brand }}
    </span>

    <span *ngIf="displayScore" class="text-gray brand">
      Score ELK: {{ product.score }}
    </span>


    <div>      
      <!-- Affichage du label Promotion -->
      <span *ngIf="product?.discount" class="label label-rounded label-error label-bold">
        {{ 'product.offer' | translate }}

        <!-- Affichage du pourcentage des remises (VITAFRAIS) -->
        <span *ngIf="isVitafrais 
                && product?.price 
                && product?.price.length > 0 
                && product?.price[0].price.discountsPercentage 
                && product?.price[0].price.discountsPercentage.length > 0">
          <span *ngFor="let discountPercentage of product?.price[0].price.discountsPercentage">
            {{ discountPercentage }}
          </span>
        </span>
      </span>

      <!-- Affichage du label Remise Bonus -->
      <span *ngIf="product?.remisesBonus" class="label label-rounded label-error label-bold">
        {{ 'product.remisesBonus' | translate }}
      </span>

      <!-- Affichage de la remise si Date courte-->
      <span *ngIf="product?.isDateCourte" class="label label-rounded label-error label-bold">
        Anti-Gaspi -50%
      </span>
    </div>
  </header>

  <a class="content" [routerLink]="['/product', product?.code]" target="_blank">
    <section>
      <!-- Affichage des pictogrammes -->
      <div class="pictos empty-div">
        <app-picto *ngFor="let p of product.pictos" [picto]="p"></app-picto>
      </div>



      <!-- Image produit -->
      <div *ngIf="product?.code" class="product-image" [style.background-image]="image"></div>
      <mat-progress-spinner *ngIf="!product?.code" class="spinner" color="primary" diameter="25" mode="indeterminate">
      </mat-progress-spinner>

      <!-- Tags (seulement trois tags à afficher) -->
      <div class="tags">
        <div *ngFor="let t of product.tags; let i = index">
          <app-tag-label [tag]="t" *ngIf="i < 3"></app-tag-label>
        </div>
      </div>

      <!-- Prix -->
      <div class="container-price">
        <div class="price" *ngIf="product?.price?.length > 0">
          <span>{{ 'product.price' | translate }} : </span>
        </div>
        <app-price *ngIf="isNetPrice" [product]="product" [priceTypeField]="'net'" [displayHelp]="true"
          [displayMoreHelp]="true"></app-price>
        <app-price *ngIf="!isNetPrice" [product]="product" [priceTypeField]="'gross'" [displayHelp]="true"
          [displayMoreHelp]="true"></app-price>
      </div>

      <ul class="block">
        <li class="weight" *ngIf="product?.weight?.gross || product?.weight?.net">
          {{ 'product.weight' | translate }} :
         <ng-container *ngIf="product?.weight?.net  && !product?.weight?.gross">
            {{ product?.weight.net + product?.weight.unit }} {{ 'product.weights.netShort' | translate }}
          </ng-container>
           <ng-container *ngIf="product?.weight?.gross">
            {{ product?.weight.gross + product?.weight.unit }} {{ 'product.weights.grossShort' | translate }}
          </ng-container>
          
        </li>
        <li *ngIf="product?.isDateCourte">
          {{ product.availability.text }}
        </li>
        <li *ngIf="product?.size">
          {{ 'product.size' | translate }} : {{ product.size }}
        </li>
        <li *ngIf="product?.origin">
          {{ 'product.origin' | translate }} : {{ product?.origin }}
        </li>
      </ul>
    </section>

    <!-- <div>
      <div class="description" *ngIf="product?.unavailabilityInfo">
        {{ product?.unavailabilityInfo?.scheduledEnd | date: 'dd/MM/yyyy'}}
      </div>
    </div> -->
  </a>

  <footer class="container">
    <i class="favorite fa fa-heart" (click)="setFavorite()" [ngClass]="{'active': product.isFavorite, 'disabled': favoriteLock}"></i>

    <!--span><i class="fa fa-shopping-cart fa-fw centered"></i></span-->
    <app-availability [product]="product" [productCode]="product.code" [outer]="product.outer"
      [unpackedQuantity]="product.unpackedQuantity" theme="light"></app-availability>
  </footer>
</div>